import { colors } from './colors';
export var borders = {
    borderWidth: '1px',
    borderWidthLarge: '2px',
    borderRadius: '2px',
    borderColor: colors.nordicBlue100,
    borderRadiusMedium: '4px',
    borderRadiusLarge: '8px',
};
